export const Members = [
  

  {
    title: "Eugene Zhu",
    img: "Eugene.webp",
    linkedin: "https://www.linkedin.com/in/eugenezhu/",
    lastPosition: "",
  },

  
  
  
  
  {
    title: "Iris Au-Yeung",
    img: "iris-mosaic.webp",
    linkedin: "https://www.linkedin.com/in/irisau-yeung/",
    lastPosition: "",
  },
  {
    title: "Johnson Luong",
    img: "Johnson.webp",
    linkedin: "https://www.linkedin.com/in/johnson-luong/",
    lastPosition: "",
  },
  {
    title: "Derek Huang",
    img: "Derek.webp",
    linkedin: "https://www.linkedin.com/in/derekhuang1/",
    lastPosition: "",
  },
  {
    title: "Fabian Siswanto",
    img: "Fabian.webp",
    linkedin: "https://www.linkedin.com/in/fabiansiswanto/",
    lastPosition: "",
  },
  
  {
    title: "Lauryn Yau",
    img: "lauryn-reelyouth.webp",
    linkedin: "https://www.linkedin.com/in/laurynyau/",
    lastPosition: "",
  },
  {
    title: "Joshua li",
    img: "joshua-reelyouth.webp",
    linkedin: "https://www.linkedin.com/in/joshuajli/",
    lastPosition: "",
  },
  {
    title: "Jimmy Hui",
    img: "Jimmy.webp",
    linkedin: "https://www.linkedin.com/in/jimmy--hui/",
    lastPosition: "",
  },
  
  
  {
    title: "Sariha Uchida",
    img: "Sariha.webp",
    linkedin: "https://www.linkedin.com/in/sariha-uchida-0b6014266/",
    lastPosition: "",
  }
];
